import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import TextField from '../shared/TextField';
import SelectField from '../shared/SelectField';

class Cathedra extends Component {
  componentDidMount() {
    const { id, didMount } = this.props;
    didMount(id);
  }

  render() {
    const { courses, curators, mentors, faculties, cathedras, specialities, curriculums, onRequestClose } = this.props;
    return (
      <div className="content-small">
        <div className="close__btn" onClick={onRequestClose}>
          <div className="first" />
          <div className="second" />
        </div>
        <div className="transition__left">
          <TextField name="name" label="Название" />
          <SelectField name="course" label="Курс" options={courses} />
          <TextField name="liter" label="Литера" />
          <SelectField name="curator" label="Куратор" options={curators} />
          <SelectField name="mentor" label="Наставник" options={mentors} />
          <SelectField name="faculty" label="Факультет" options={faculties} />
          <SelectField name="cathedra" label="Кафедра" options={cathedras} />
          <SelectField name="specialty" label="Специальность" options={specialities} />
          <SelectField name="curriculum" label="Учебный план" options={curriculums} />
        </div>
        <div className="transition__right group-transition__right">
          <SelectField name="recruitmentYear" label="Год набора" options={mentors} />
          <SelectField name="yearOfIssue" label="Год выпуска" options={mentors} />
          <SelectField name="selfStudyAudience" label="Аудитория самоподготовки" options={mentors} />
          <SelectField name="accommodation" label="Размещение" options={mentors} />
        </div>
        <div className="transition__right_second">
        </div>
        <div className="table table__next">
          <div className="table__lable">Состав</div>
          <table className="tg-second">
            <tr>
              <th>№</th>
              <th>Фамилия имя отчество</th>
              <th>Статус</th>
              <th>Дата</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Александров Глеб Янович</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Бобров Иннокентий Петрович</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Вельмипонежев Роман Сергеевич</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Иколкин Василий  Васильевич </td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Краснухин Петр Иваныч</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Поленов-Перескоков Александр Андреевич</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Разумения Вахтанг Мриевич</td>
              <td className="position">Переведен на следующий курс</td>
              <td className="position">20.07.12</td>
            </tr>
          </table>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'group',
  enableReinitialize: true,
})(Cathedra);
